import * as actionConsts from './actions';
import update from 'react/lib/update';

export const initState = {
  isLoading: false,
  workplace: {
    id: 'dummyId',
    name: '',
    client: {
      name: '',
      id: 'dummyId',
      contact: {
        name: '',
        id: 'dummyId'
      }
    },
    project: {
      id: 'dummyId',
      name: '',
      number: ''
    },
    headsub: [
      { heading: 'Faktura adresse', subtext: '', editMode: true },
      { heading: 'Faktura mail', subtext: '', editMode: true },
      { heading: 'CVR', subtext: '', editMode: true },
      { heading: 'EAN', subtext: '', editMode: true },
      { heading: 'Kundens projektnr', subtext: '', editMode: true },
      { heading: 'Betalingsbetingelser', subtext: '', editMode: true },
    ]
  },
  dailyReports: [],
  approvementCount: {
    approved: 0,
    notApproved: 0
  },
  dailyReportsSkip: 0,
  projectNumberReserved: {
    projectNumber: "",
    reserved: false
  },
  projectSuggestions: [],
  clients: [],
  clientSuggestions: [],
  contactSuggestions: [],
  isSavingWorkplace: false
}

export default (state = initState, action) => {
  switch (action.type) {
    case actionConsts.GET_WORKPLACE_REQUEST:
      return update(state, {
        isLoading: {
          $set: true
        }
      });
    case actionConsts.GET_WORKPLACE_SUCCESS:
      return update(state, {
        isLoading: {
          $set: false
        },
        workplace: {
          $set: action.workplace
        }
      });
    case actionConsts.GET_WORKPLACE_FAILURE:
      return update(state, {
        isLoading: {
          $set: true
        }
      });
    case actionConsts.EDIT_CREATE_WORKPLACE_REQUEST:
      return update(state, {
        isSavingWorkplace: {
          $set: true
        }
      });
    case actionConsts.CREATE_WORKPLACE_SUCCESS:
    case actionConsts.EDIT_WORKPLACE_SUCCESS:
      return update(state, {
        isSavingWorkplace: {
          $set: false
        },
        workplace: {
          $set: action.updatedWorkplace
        }
      });
    case actionConsts.EDIT_CREATE_WORKPLACE_FAILURE:
      return update(state, {
        isSavingWorkplace: {
          $set: false
        }
      });
    case actionConsts.DELETE_WORKPLACE_REQUEST:
      return update(state, {
        isLoading: {
          $set: true
        }
      });
    case actionConsts.DELETE_WORKPLACE_SUCCESS:
      return update(state, {
        isLoading: {
          $set: false
        }
      });
    case actionConsts.GET_DAILY_REPORTS_SUCCESS:
      return update(state, {
        dailyReports: {
          $splice: [[action.oldSkip, 0, ...action.dailyReports]]
        },
        approvementCount: {
          $set: action.approvementCount
        },
        dailyReportsSkip: {
          $set: action.dailyReportsSkip
        }
      });
    case actionConsts.GET_DAILY_REPORTS_SUCCESS_INIT:
      return update(state, {
        dailyReports: {
          $set: action.dailyReports
        },
        approvementCount: {
          $set: action.approvementCount
        },
        dailyReportsSkip: {
          $set: action.dailyReportsSkip
        }
      });
    case actionConsts.DAILY_REPORT_TOGGLE_APPROVED_REQUEST:
    case actionConsts.DAILY_REPORT_TOGGLE_APPROVED_FAILURE:
      return update(state, {
        dailyReports: {
          [action.dailyReportIndex]: {
            approved: {
              $set: action.approved
            }
          }
        }
      });
    case actionConsts.DAILY_REPORT_TOGGLE_APPROVED_SUCCESS:
      return update(state, {
        approvementCount: {
          $set: action.approvementCount
        }
      });
    case actionConsts.DAILY_REPORT_TOGGLE_INVOICED_REQUEST:
    case actionConsts.DAILY_REPORT_TOGGLE_INVOICED_FAILURE:
      return update(state, {
        dailyReports: {
          [action.dailyReportIndex]: {
            invoiced: {
              $set: action.invoiced
            }
          }
        }
      });
      case actionConsts.DAILY_REPORT_TOGGLE_BOG_REQUEST:
      case actionConsts.DAILY_REPORT_TOGGLE_BOG_FAILURE:
        return update(state, {
          dailyReports: {
            [action.dailyReportIndex]: {
              bog: {
                $set: action.bog
              }
            }
          }
        });
    case actionConsts.WORKPLACE_IS_PROJECTNUMBER_RESERVED_SUCCESS:
      return update(state, {
        projectNumberReserved: {
          $set: action.projectNumberReserved
        }
      });
    case actionConsts.GET_PROJECT_SUGGESTIONS_SUCCESS:
      return update(state, {
        projectSuggestions: {
          $set: action.suggestions
        }
      });
    case actionConsts.GET_CLIENT_SUGGESTIONS_SUCCESS:
      return update(state, {
        clientSuggestions: {
          $set: action.suggestions
        }
      });
    case actionConsts.GET_CONTACT_SUGGESTIONS_SUCCESS:
      return update(state, {
        contactSuggestions: {
          $set: action.suggestions
        }
      });
    case actionConsts.WORKPLACE_OVERVIEW_SET_INIT_STATE:
      return update(state, {
        $set: initState
      });
    case actionConsts.ADD_HEADINGSUBTEXT_WORX:
      return update(state, {
        workplace: {
          headsub: {
            $push: [action.headingSubtextObj]
          }
        },
      })
    case actionConsts.UPDATE_HEADING_WORX:
      return update(state, {
        workplace: {
          headsub: {
            [action.index]: {
              heading: {
                $set: action.text
              },
              editMode: {
                $set: true
              }
            }
          },
        }
      })
    case actionConsts.UPDATE_SUBTEXT_WORX:
      return update(state, {
        workplace: {
          headsub: {
            [action.index]: {
              subtext: {
                $set: action.text
              },
              editMode: {
                $set: true
              }
            }
          },
        }
      })
    case 'KILL_WORKPLACE':
      return initState
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Overview/reducer.js